/**
@ngdoc directive
@name submitOnEnter

@description
This directive has been created for textarea (expandable textarea in Search screen specifically),
so the user doesn't have to navigate to the Search button and can hit Enter key instead
(reflecting the way the input was working before expandable textarea change)

@param {expression} submit-on-enter it can evaluate the code passed as a parameter before submit

*/
(function(){
    var submitOnEnter = function($timeout){
        return {
            link: function(scope, element, attrs, formCtrl) {
                element.bind('keydown', function(event){
                    var keyCode = event.which || event.keyCode;
                    if(keyCode == 13) { // if ENTER key
                        event.preventDefault();
                        if(attrs.submitOnEnter!=''){
                            scope.$eval(attrs.submitOnEnter);
                        }
                        $timeout(function(){
                            angular.element(element).closest('form').submit();
                        });
                    }
                });
            }
        };
    };
    submitOnEnter.$inject = ['$timeout'];
    angular.module('app').directive('submitOnEnter', submitOnEnter);

    var moreLikeThisEnterSubmit = function () {
        return function (scope, element, attrs) {
            element.bind('keydown', function (event) {
                if (event.which == 13) {
                    event.preventDefault();
                    window.stop();
                    document.execCommand('Stop');
                    var elementList = angular.element(element).parent().find("a");
                    if(elementList != null) {
                        var hyperlink = elementList[0];
                        if(hyperlink != null && hyperlink.innerText == "More Like This") {
                            hyperlink.click();
                        }
                    }
                    return false;
                }
            });
        };
    };
    angular.module('app').directive('moreLikeThisEnterSubmit', moreLikeThisEnterSubmit);

}());